var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chart',{attrs:{"options":_vm.chartOptions,"auto-resize":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }